const pages = [
    {
      parent: null,
      id: "overdose-crisis",
      title: "Opioid Overdose Crisis",
      navLink: "/overdose-crisis"
    },
    {
      parent: null,
      id: "about-nalmefene-hcl",
      title: "About Nalmefene HCl",
      navLink: "/about-nalmefene-hcl",
    },
    {
      parent: null,
      id: "administration-and-dosing",
      title: "Administration and Dosing",
      navLink: "/administration-and-dosing",
    },
    {
      parent: null,
      id: "ordering-resources",
      title: "How to Order",
      navLink: "/ordering-resources",
    },
    {
      parent:"overdose-crisis",
      id: "opioids-and-synthetic-opioids",
      title: "Opioids and Synthetic Opioids",
      navLink: "/overdose-crisis/#p1",
    },
    {
        parent:"overdose-crisis",
        id: "opioid-reversal-agents",
        title: "Opioid Reversal Agents",
        navLink: "/overdose-crisis/#p2",
      },
    {
      parent:"about-nalmefene-hcl",
      id: "duration-of-action",
      title: "Duration of Action",
      navLink: "/about-nalmefene-hcl/#p1",
    },
    {
        parent:"about-nalmefene-hcl",
        id: "efficacy",
        title: "Efficacy",
        navLink: "/about-nalmefene-hcl/#p2",
      },
      {
        parent:"about-nalmefene-hcl",
        id: "safety-and-tolerability",
        title: "Safety and Tolerability",
        navLink: "/about-nalmefene-hcl/#p3",
      },
    {
      parent:"administration-and-dosing", 
      id: "administration",
      title: "Administration",
      navLink: "/administration-and-dosing/#p2",
    },
    {
        parent:"administration-and-dosing", 
        id: "dosing",
        title: "Dosing",
        navLink: "/administration-and-dosing/#p1",
      },
  ];
  
  export default pages;
  